import { render } from "./shinsei_Shutchoedit.vue?vue&type=template&id=5507ffd7&scoped=true&ts=true"
import script from "./shinsei_Shutchoedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Shutchoedit.vue?vue&type=script&lang=ts"

import "./shinsei_Shutchoedit.vue?vue&type=style&index=0&id=5507ffd7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5507ffd7"]])

export default __exports__